import {
  formatUnit,
  isValidAddress,
  pickNumberResponse,
  rpcContractCall,
  useWallet,
} from '@bifrost-platform/bifront-sdk-react-wallet';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { FRAG_LP_REWARD_TOTAL_SUPPLY } from '@/configs/fragment';
import useEnv from '@/hooks/useEnv';
import useIsBifrostChain from '@/hooks/useIsBifrostChain';
import { formatNumber } from '@/libs/formatNumber';
import {
  everdexLpRewardTotalSupplyAtom,
  everdexIsLoadingLpRewardTotalSupplyAtom,
} from '@/store/everdexStore';

const useEverdexLpRewardTotalSupply = (proxyAddress?: string) => {
  const { chainBifrost } = useEnv();

  const { wallet, account } = useWallet();
  const isBifrostChain = useIsBifrostChain();

  const [totalSupply, setTotalSupply] = useAtom(everdexLpRewardTotalSupplyAtom);
  const [isLoading, setIsLoading] = useAtom(
    everdexIsLoadingLpRewardTotalSupplyAtom
  );

  const sync = useCallback(async () => {
    if (!(proxyAddress && isValidAddress(proxyAddress))) {
      return;
    }

    setIsLoading(true);

    try {
      const to = proxyAddress;
      const fragment = FRAG_LP_REWARD_TOTAL_SUPPLY;
      const values: ReadonlyArray<any> = [];
      const from = account;
      const defaultBlock = 'latest';

      let totalSupply = '0';

      if (isBifrostChain) {
        totalSupply = pickNumberResponse(
          await wallet.call(to, fragment, values, from, defaultBlock)
        );
      } else {
        const rpcURL = chainBifrost.rpcUrls[0];
        const callParams = {
          from,
          to,
          signature: fragment,
          values,
        };

        totalSupply = pickNumberResponse(
          await rpcContractCall(callParams, rpcURL, defaultBlock)
        );
      }

      setTotalSupply(formatNumber(formatUnit(totalSupply, 18)));
    } catch (error) {}

    setIsLoading(false);
  }, [
    account,
    chainBifrost.rpcUrls,
    isBifrostChain,
    proxyAddress,
    setIsLoading,
    setTotalSupply,
    wallet,
  ]);

  return { totalSupply, isLoading, sync };
};

export default useEverdexLpRewardTotalSupply;
